import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PlayCircle } from "lucide-react";

export const FootballTitle = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 text-white">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-blue-500/20 blur-3xl" />
        <div className="absolute -bottom-20 -left-24 h-80 w-80 rounded-full bg-purple-500/20 blur-3xl" />
        <div className="absolute left-1/2 top-1/2 h-[420px] w-[820px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/5 blur-3xl" />
      </div>

      <div className="relative mx-auto flex min-h-[100dvh] max-w-7xl items-center px-4 py-28 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)]">
          <div className="space-y-8">
            {/* <div className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm font-semibold tracking-[0.2em] text-blue-100 backdrop-blur-xl">
              {t("football.hero.badge")}
            </div> */}

            <div className="space-y-5">
              <h1 className="max-w-3xl text-4xl font-bold tracking-tight text-white md:text-6xl lg:text-7xl">
                {t("football.hero.title")}
              </h1>
              <p className="max-w-2xl text-base leading-8 text-slate-300 md:text-lg">
                {t("football.hero.description")}
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <button
                onClick={() => navigate("/register-selection")}
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-500 to-blue-500 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-blue-500/20 transition-all duration-300 hover:scale-[1.02] hover:shadow-blue-500/30"
              >
                <PlayCircle className="h-4 w-4" />
                {t("football.hero.primaryCta")}
              </button>
              {/* <button
                type="button"
                onClick={() => navigate("/product")}
                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/5 px-6 py-3.5 text-sm font-semibold text-white backdrop-blur-xl transition-all duration-300 hover:border-white/20 hover:bg-white/10"
              >
                {t("football.hero.secondaryCta")}
                <ArrowRight className="h-4 w-4" />
              </button> */}
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-blue-500/20 to-purple-500/20 blur-2xl" />
            <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-slate-950/60 shadow-2xl shadow-black/30 backdrop-blur-xl">
              <div className="aspect-video">
                <video
                  src="https://public.wizardfootball.com/videos/WizardFootballPromo.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls
                  controlsList="nodownload"
                  className="h-full w-full object-cover"
                />
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
